<template>
  <div class="flex flex-col gap-y-2">
    <span v-if="oauthError" class="input-error text-destructive text-sm mt-2">{{ t('auth.login.social-error') }}</span>

    <div class="flex flex-col gap-2" v-bind="$attrs">
      <Button class="w-full" variant="outline" @click="connectWithAlternateService('v2/oauth2/login/google-oauth2/', 'login')">
        <Google class="w-6 h-6" />
        <span class="text-muted-foreground translate-y-[1px]">{{ t('auth.login.social-google') }}</span>
      </Button>
      <Button class="w-full" variant="outline" @click="connectWithAlternateService('v2/oauth2/login/linkedin-openidconnect/', 'login')">
        <LinkedIn class="w-6 h-6" />
        <span class="text-muted-foreground translate-y-[1px]">{{ t('auth.login.social-linkedin') }}</span>
      </Button>
      <Button class="w-full" variant="outline" @click="connectWithAlternateService('v2/oauth2/login/apple-id/', 'login')">
        <Apple class="w-6 h-6" />
        <span class="text-muted-foreground translate-y-[1px]">{{ t('auth.login.social-apple') }}</span>
      </Button>
      <Button class="w-full" variant="outline" @click="connectWithAlternateService('v2/oauth2/login/microsoft-graph/', 'login')">
        <Microsoft class="w-6 h-6" />
        <span class="text-muted-foreground translate-y-[1px]">{{ t('auth.login.social-microsoft') }}</span>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Google from '~/assets/icons/social/Google.vue'
import Apple from '~/assets/icons/social/Apple.vue'
import Microsoft from '~/assets/icons/social/Microsoft.vue'
import LinkedIn from '~/assets/icons/social/LinkedIn.vue'

const emit = defineEmits(['on-success'])

const props = defineProps<{
  onSuccess?: () => void
}>()

const { t } = useI18n()
const { connectWithAlternateService, hasError: oauthError } = useOauthServices({
  onSuccess(): void {
    props.onSuccess?.()
    emit('on-success')
  },
})
</script>
